import Accordion, { AccordionItem } from '@ingka/accordion';
import Table, { TableBody } from '@ingka/table';
import Text from '@ingka/text';
import { sortEmailContent } from '@lotta/shared/util-lottery-sorting';
import { useTranslation } from 'react-i18next';
import styles from '../LotteryConfigOverview.module.scss';
import type { LotteryConfigData } from '../types';

type EmailContent = {
  [key: string]: string;
};

export const PrizeEmailTable: React.FC<{
  values: LotteryConfigData;
}> = ({ values: { translation, lottery } }) => {
  const { t } = useTranslation();

  const emailFields: EmailContent = {
    subjectLine: t('lottery-form-email-form-email-subject-line'),
    preHeader: t('lottery-form-email-form-email-pre-header'),
    bodyHeadline: t('lottery-form-email-form-email-body-title'),
    body: t('lottery-form-email-form-email-body-content'),
    disclaimerText: t('lottery-form-email-form-email-disclaimer'),
    ctaText: t('lottery-form-email-form-email-button'),
    ctaLink: t('lottery-form-email-form-email-button-link'),
  };

  return (
    <>
      <Table>
        <TableBody className={styles['tbody']}>
          <tr key="email-image-url">
            <td className={styles['heading']}>
              <Text>{t('lottery-form-email-form-email-image-label')}</Text>
            </td>
            <td>
              <Text>{lottery.emailTemplate?.bannerImageUrl}</Text>
            </td>
          </tr>
        </TableBody>
      </Table>
      <div className={styles['sub-accordion']}>
        <Accordion>
          {Object.entries(translation).map(([language, data]) => {
            const capitalizedLanguage = language.toUpperCase();
            const { email } = data;
            if (!email) {
              return null;
            }
            const { body, ...rest } = email.winner;
            const emailContent = {
              ...rest,
              body: body.copy.map(({ bodyCopy }) => bodyCopy).join('\n\n'),
            };

            return (
              <AccordionItem
                title={`${t('form-accordion-email-translations-language', {
                  capitalizedLanguage,
                })}`}
                id={`email-${capitalizedLanguage}`}
                key={`email-${capitalizedLanguage}`}
                open={Object.entries(translation).length === 1}
              >
                <Table>
                  <TableBody className={styles['tbody']}>
                    {(Object.keys(emailContent) as Array<keyof typeof emailContent>)
                      .sort(sortEmailContent)
                      .filter((key) => key !== 'ctaText' || !!emailContent[key])
                      .map((emailDetail) => {
                        return (
                          <tr key={`${emailDetail}-${capitalizedLanguage}`}>
                            <td className={styles['heading']}>{emailFields[emailDetail]}</td>
                            <td>{emailContent[emailDetail]}</td>
                          </tr>
                        );
                      })}
                  </TableBody>
                </Table>
              </AccordionItem>
            );
          })}
        </Accordion>
      </div>
    </>
  );
};
